import React, { Component, Fragment } from 'react';
import 'rheostat/initialize';
// import Rheostat from 'rheostat'
// import DefaultTheme from 'rheostat/lib/themes/DefaultTheme'
import InputRange from 'react-input-range'
import RangeSliderGroup from '../components/rangeslidergroup.js'
import CheckboxGroup from '../components/checkboxgroup.js'
import { slugify } from '../helpers.js'
import { Validation } from 'calidation'
import ReCAPTCHA from "react-google-recaptcha"




class Step extends Component {
  constructor(props) {
    super(props)
    // this.recaptcaChange = this.recaptcaChange.bind(this);
  }

  render() {
    let formValidationConfig = {}

    let emailValidationConfig = {
      isRequired: 'This field is required!',
      isEmail: 'Please enter a valid e-mail address',
    }

    // regex: /^\d{4}$/,
    // isBlacklisted : {
    //   message: 'Please use a business email address',
    //   blacklist: ['gmail.com'],
    // }


    const { step, currentStep, stepNum } = this.props
    if (currentStep !== stepNum) { // Prop: The current step
      return null
    }


    return(
      <div className="form-group">
        <label className="form-group__label">{ step['label'] }</label>
        {
          (step['content']['type'] === "MultiChoice") ?
          (

              <CheckboxGroup
                label={step['label']}
                choices={step['content']['options']['choices']}
                selectedChoices={this.props.selectedChoices}
                groupUpdated={this.props.handleChange}
              />
          ) : ''
        }

        {
          (step['content']['type'] === "Range") ?
          (
            <div className="slider-group">
              <RangeSliderGroup
                label={step['label']}
                stepAmmount={step['content']['options']['stepamount']}
                initialValues={[step['content']['options']['min'], step['content']['options']['max']]}
                markers={step['content']['options']['markers']}
                sliderChange={this.props.sliderChange}
              />
            </div>
          ) : ''
        }
        {
          (step['content']['type'] === "Submit") ?
          (
            <div className="field-group">
              <p className="h4"><strong>A little more about you, then we're all set</strong></p>

              <div className="field-group__inputs">
                {

                  Object
                    .keys(step['content']['options']['inputs']['fields'])
                    .map( (key, index) => {


                      if( step['content']['options']['inputs']['fields'][key]['type'] === "email" ) {
                        formValidationConfig[ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` ] = emailValidationConfig
                      }
                      // } else {
                        // formValidationConfig[ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` ] = {
                        //   isRequired: 'This field is required!'
                        // }
                      // }

                      return (
                        <Validation key={key} config={ formValidationConfig }>
                        {({ fields, errors, isValid, submitted }) => (
                          <div>
                          <label htmlFor={ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` }>{ step['content']['options']['inputs']['fields'][key]['label'] }{step['content']['options']['inputs']['fields'][key]['isrequired'] ? " *" : ""}</label>
                          <input
                          { ...step['content']['options']['inputs']['fields'][key]['isrequired'] ? { required: true } : {} }
                          className="form-control"
                          name={ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` }
                          id={ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` }
                          type={ step['content']['options']['inputs']['fields'][key]['type'] }
                          onChange={ (e) => this.props.personalDetails[ step['content']['options']['inputs']['fields'][key]['label'] ] = e.target.value }
                          />
                          {
                            (step['content']['options']['inputs']['fields'][key]['isrequired'] && submitted && errors[ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` ]) ?
                            <span className="not-valid">{errors[ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` ]}</span>
                            : ''
                          }
                          </div>
                        )}
                        </Validation>

                      )

                      // return (
                      //   <div key={key}>
                      //     <label htmlFor={ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` }>{ step['content']['options']['inputs']['fields'][key]['label'] }</label>
                      //     <input
                      //       required
                      //       className="form-control"
                      //       id={ `details__${slugify(step['content']['options']['inputs']['fields'][key]['label'])}` }
                      //       type={ step['content']['options']['inputs']['fields'][key]['type'] }
                      //       onBlur={ (e) => this.props.personalDetails[ step['content']['options']['inputs']['fields'][key]['label'] ] = e.target.value }
                      //     />
                      //   </div>
                      // )
                    })
                }



              </div>
              <div className="recaptcha">
                <ReCAPTCHA
                sitekey="6LeQxdcUAAAAAL8KJsJ6DLwiXbKbJuoOT94Jt791"
                onChange={this.props.recaptcaChange}
                theme="light"
                size="normal"
                />
              </div>

            </div>

          ) : ''
        }

        {
          /*
          <input
            className="form-control"
            id="email"
            name="email"
            type="text"
            placeholder="Enter email"
            value={this.props.email} // Prop: The email input data
            onChange={this.props.handleChange} // Prop: Puts data into state
          />
          */
        }
      </div>
    )
  }
}

export default Step;
